module.exports = __webpack_public_path__ + "static/droogte-klimaatverandering-satelliet-sentinel-2-esa-489241634ec3d7a4ea4ec20b6b767e26.jpg";